import { calculateRotation } from '@keen.io/charts-utils';
var getRotatedDimension = function (_a) {
    var radiusAngle = _a.radiusAngle, dimension = _a.dimension;
    if (radiusAngle === 0)
        return dimension;
    if (Math.abs(radiusAngle) === 90) {
        return {
            height: dimension.width,
            width: dimension.height,
        };
    }
    return calculateRotation(dimension.width, dimension.height, radiusAngle);
};
export default getRotatedDimension;
